
import { useState } from "react";
import styled from "styled-components";
import 'react-toastify/dist/ReactToastify.css';
import Select from 'react-select';
import { toast } from 'react-toastify';
import Swal from "sweetalert2";
import GreenButton from '../../ui/GreenButton.js';


const DivGeral = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background-color: #fff;
  padding: 25px;
  box-shadow: 0px 0px 2px #ccc;

`;


const Label = styled.label`
  color: #4f4f4f;
  font-weight: bold;
  font-size: 17px;  
  display: flex;
  flex-direction: column;
    margin-top: 1rem;
  select {
    &.erro {
      border: 2px solid red;
      
    }
  }
`;






const Div = styled.div`
  display: flex;
  flex-direction:row;
  justify-content: center;
  gap: 1rem;
  margin-top: 1rem;

  select {
    width: 250px;
    padding: 0 10px;
    border: 1px solid #bbb;
    border-radius: 5px;
    height: 37px;
  }

`;

const H2 = styled.h2`
  color: #575757;
`;




const SelectContainer = styled.div`


  .custom-select__control {
    border-radius: 6px;
    padding: 2px 0px;
    height: 35px;
    width: 700px;
    box-shadow: none;
    font-weight: normal;
    &:hover {
      border-color: #888;
    }
    &.erro {
      border: 2px solid red;
    
    }
  }

  .custom-select__menu {
    z-index: 9999; /* Isso garante que fique acima do modal */
  }

  .custom-select__menu-list {
    max-height: 120px; /* ~3 itens */
    overflow-y: auto;
  }

  .custom-select__option {
    padding: 2px 0px;
    color: #575757;
    background-color: #fff;
    font-weight: normal;
  }

  .custom-select__placeholder {
    color: #999;
    font-weight: normal;
  }

  .custom-select__single-value {
    color: #000;
    font-weight: normal;

  }

  .custom-select__control.erro {
    border: 2px solid red;
  }


  select {
    width: 700px;
  }
`;


const TextAreaContainer = styled.div`
  margin-top: 8px;
  width: 700px;

    
`;

const TextAreaStyled = styled.textarea`
  width: 100%;
  min-height: 100px;
  padding: 12px;
  font-size: 16px;
  border-radius: 6px;
  border: 1px solid #ccc;
  resize: vertical;
  background-color: #f9f9f9;
  color: #333;
  font-family: inherit;
  box-sizing: border-box;

  &:focus {
    outline: none;
    border-color: #007bff;
    background-color: #fff;
  }

  &.erro {
      border: 2px solid red;
      
    }
  @media (max-width: 768px) {
    font-size: 14px;
  }
`;





const Form = ({ urlApi, listaEquipamento, setAtualizaDasboard, usuarioEquipamento, tipoChamado, subTipoChamado, itemSubTipoChamado, modalNovoChamado, tipoAcessoModulo8 }) => {
  //========================================================TOKEN
  const token = localStorage.getItem('token');
  const id = Number(localStorage.getItem('id'));


  const [tipoSelecionado, setTipoSelecionado] = useState('');
  const [subTipoChamadoSelecionado, setSubTipoChamadoSelecionado] = useState('');
  const [subTiposFiltrados, setSubTiposFiltrados] = useState([]);
  const [itemSubTipoChamadoSelecionado, setItemSubTipoChamadoSelecionado] = useState('');
  const [itemSubTiposFiltrados, setItemSubTiposFiltrados] = useState([]);
  const [descricaoChamado, setDescricaoChamado] = useState('');


  const [usuarioEquipamentoSelecionado, setUsuarioEquipamentoSelecionado] = useState(id);



  //Usuários do SELECT
  const opcoesUsuarios = usuarioEquipamento.map((tipo) => ({
    value: tipo.Cod_Func,
    label: `${tipo.Cod_Func} - ${tipo.Desc_Func} - ${tipo.Desc_Departamento}`,
  }));


  const showPopUp = () => {
    return new Promise((resolve) => {
      Swal.fire({
        title: "Deseja continuar?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        customClass: {
          container: 'custom-swal-container',
        },
      }).then((result) => {
        resolve(result.value); // Resolve a Promise com o valor result.value
      });
    });
  };

  const [erros, setErros] = useState({});
  const [salvando, setSalvando] = useState(false);

  const salvarChamado = async () => {

    const userConfirmed = await showPopUp();
    if (!userConfirmed) {
      return;
    }

    if (salvando) return;

    if (!token) {
      toast.error('Sessão expirada. Faça login novamente.');
      return;
    }

    setSalvando(true);

    const novosErros = {};

    if (
      !descricaoChamado ||
      descricaoChamado.trim().length < 50 ||
      descricaoChamado.trim().length > 500
    ) {
      novosErros.descricao = true;
    }

    // Validação de 3+ caracteres repetidos
    if (descricaoChamado && /(.)\1\1/.test(descricaoChamado)) {
      novosErros.repetidos = true;
    }

    if (!tipoSelecionado) {
      novosErros.tipo = true;
    }

    if (!subTipoChamadoSelecionado) {
      novosErros.subTipo = true;
    }

    if (!itemSubTipoChamadoSelecionado) {
      novosErros.itemSubTipo = true;
    }

    if (Object.keys(novosErros).length > 0) {
      setErros(novosErros);

      if (Object.keys(novosErros).length > 0) {
        if (novosErros.repetidos) {
          toast.warn('Remova sequências de 3 ou mais caracteres iguais (ex: aaa, 111, ...).');
        } else if (novosErros.descricao) {
          const len = descricaoChamado.trim().length;
          if (len < 50) toast.warn('A descrição deve ter no mínimo 50 caracteres.');
          else if (len > 500) toast.warn('A descrição deve ter no máximo 500 caracteres.');
        } else {
          toast.warn('Preencha todos os campos obrigatórios corretamente.');
        }
      }


      setSalvando(false); // ⚠️ importante: liberar o botão em caso de erro
      return;
    }



    setErros({});

    try {
      const payload = {
        cod_funcionario: id,
        cod_funcionario_solicitante: usuarioEquipamentoSelecionado || id,
        tipo_chamado: tipoSelecionado,
        subtipo_chamado: subTipoChamadoSelecionado,
        item_subtipo_chamado: itemSubTipoChamadoSelecionado,
        descricao: descricaoChamado.trim(),
        tag_equipamento: tagSelecionada,
      };

      const response = await fetch(`${urlApi}central-ti/adicionar-chamado`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(payload),
      });

      if (response.ok) {
        const data = await response.json();
        toast.success(data?.message || 'Chamado adicionado com sucesso!');
        setAtualizaDasboard(true);
        setTimeout(() => {
          modalNovoChamado();
        }, 2000);
      } else {
        const err = await response.json();

        if (err?.campo === 'descricao') {
          setErros({ descricao: true });
        }

        toast.error(err?.error || 'Erro ao salvar chamado.');
      }

    } catch (error) {
      toast.error(error.message || 'Erro inesperado ao salvar chamado.');
    } finally {
      setSalvando(false);
    }

    setTipoSelecionado('');
    setSubTipoChamadoSelecionado('');
    setItemSubTipoChamadoSelecionado('');
    setDescricaoChamado('');
    setUsuarioEquipamentoSelecionado('');
  };





  //---------------------------FILTRA O ASSUNTO DO CHAMADO
  const handleTipoChange = (e) => {
    const codSelecionado = e.target.value;
    setTipoSelecionado(codSelecionado)
    setSubTipoChamadoSelecionado(''); // limpa subtipo

    const filtrados = subTipoChamado.filter(
      (s) => String(s.COD_TIPOCHAMADO) === String(codSelecionado)
    );
    setSubTiposFiltrados(filtrados);
  };

  //---------------------------FILTRA O DETALHAMENTO DO CHAMADO
  const handleSubTipoChange = (e) => {
    const codSelecionado = e.target.value;
    setSubTipoChamadoSelecionado(codSelecionado)
    setItemSubTipoChamadoSelecionado(''); // limpa subtipo

    const filtrados = itemSubTipoChamado.filter(
      (s) => String(s.COD_SUBTIPOCHAMADO) === String(codSelecionado)
    );
    setItemSubTiposFiltrados(filtrados);
  };



  const [tagSelecionada, setTagSelecionada] = useState(null);

  const regrasFiltroTipoEquipamento = {
    181: [1],        // subTipo 181 → mostrar apenas equipamentos tipo 2
    182: [2],     // subTipo 182 → tipo 1 ou 3
    183: [3],
    183: [7],
  };




  const [dadosUsuarioSelecionado, setDadosUsuarioSelecionado] = useState(() => {
    return usuarioEquipamento.find(u => u.Cod_Func == id) || null;
  });

  // Este é o valor de Cod_Objeto usado no filtro
  const codObjetoSelecionado = dadosUsuarioSelecionado?.Cod_Objeto;

  // Os tipos permitidos continuam como estão
  const tiposPermitidos = regrasFiltroTipoEquipamento[subTipoChamadoSelecionado];


  // Filtro de equipamentos baseado no Cod_Objeto + tiposPermitidos
  const equipamentosFiltrados = listaEquipamento.filter(equip => {
    const pertenceAoObjeto = equip.COD_OBJETOCUSTO === codObjetoSelecionado;

    if (tiposPermitidos) {
      return pertenceAoObjeto && tiposPermitidos.includes(equip.ID_TIPO_EQUIPAMENTO);
    }

    return pertenceAoObjeto;
  });




  const opcoesEquipamentos = equipamentosFiltrados.map(equip => ({
    value: equip.TAG_EQUIPAMENTO,
    label: equip.TAG_EQUIPAMENTO,
    equipamento: equip
  }));




  const equipamentoDesabilitado = !tipoSelecionado || !subTipoChamadoSelecionado;

  return (
    <DivGeral>
      <H2>Novo Chamado</H2>



      <Div>
        {(tipoAcessoModulo8 === 'A' || tipoAcessoModulo8 === 'G') && (
          <Label>
            Caso o chamado esteja sendo aberto para outro usuário, favor selecionar o mesmo:
            <SelectContainer>
              <Select
                classNamePrefix="custom-select"
                options={opcoesUsuarios}
                value={opcoesUsuarios.find(opt => opt.value === usuarioEquipamentoSelecionado)}
                onChange={(selected) => {
                  const codFunc = selected?.value || '';
                  setUsuarioEquipamentoSelecionado(codFunc);

                  const usuarioSelecionado = usuarioEquipamento.find(u => u.Cod_Func === codFunc);
                  setDadosUsuarioSelecionado(usuarioSelecionado || null);
                }}
                placeholder="Selecione o usuário"
                isClearable
              />



            </SelectContainer>


          </Label>
        )}


      </Div>
      <Div>
        <Label>
          Selecione o tipo de chamado:
          <SelectContainer>
            <select
              className={erros.tipo ? 'erro' : ''}
              value={tipoSelecionado}
              onChange={handleTipoChange}
            >
              <option value="">Escolha uma opção</option>
              {tipoChamado.map((tipo) => (
                <option key={tipo.COD_TIPOCHAMADO} value={tipo.COD_TIPOCHAMADO}>
                  {tipo.DESC_TIPOCHAMADO}
                </option>
              ))}
            </select>
          </SelectContainer>

          <div style={{ marginTop: '8px', fontSize: '14px', color: '#555' }}>
            <strong>Observações:</strong>
            <ul style={{ marginTop: '4px', paddingLeft: '18px' }}>
              <li><strong>Hardware:</strong> Problemas com equipamentos físicos (ex: computadores, impressoras).</li>
              <li><strong>Rede:</strong> Problemas de internet, conexão ou rede interna.</li>
              <li><strong>Sistemas:</strong> Erros em sistemas, sites, aplicativos ou softwares em geral.</li>
            </ul>
          </div>
        </Label>

      </Div>

      <Div>
        <Label>
          Selecione o assunto do chamado:
          <SelectContainer>
            <select
              value={subTipoChamadoSelecionado}
              onChange={handleSubTipoChange}
              className={erros.subTipo ? 'erro' : ''}

            >
              <option value="">Escolha uma opção</option>
              {subTiposFiltrados.map((i) => (
                <option key={i.COD_SUBTIPOCHAMADO} value={i.COD_SUBTIPOCHAMADO}>
                  {i.DESC_SUBTIPOCHAMADO}
                </option>
              ))}
            </select>
          </SelectContainer>


        </Label>


      </Div>

      <Div>
        <Label>
          Selecione o detalhamento do chamado:
          <SelectContainer>
            <select
              value={itemSubTipoChamadoSelecionado}
              onChange={(e) => setItemSubTipoChamadoSelecionado(e.target.value)}
              className={erros.itemSubTipo ? 'erro' : ''}
            >
              <option value="">Escolha uma opção</option>
              {itemSubTiposFiltrados.map((i) => (
                <option key={i.COD_ITEMSUBTIPOCHAMADO} value={i.COD_ITEMSUBTIPOCHAMADO}>
                  {i.DESC_ITEMSUBTIPOCHAMADO}
                </option>
              ))}
            </select>
          </SelectContainer>


        </Label>


      </Div>

      <Div>
        <Label>
          Selecione o equipamento:
          <SelectContainer>
            <Select
              classNamePrefix="custom-select"
              options={opcoesEquipamentos}
              value={opcoesEquipamentos.find(opt => opt.value === tagSelecionada)}
              onChange={(selected) => {
                const tag = selected?.value || '';
                setTagSelecionada(tag);

                // const equipamentoSelecionado = listaEquipamento.find(e => e.TAG_EQUIPAMENTO === tag);

              }}

              placeholder="Selecione o equipamento"
              isClearable
              isDisabled={equipamentoDesabilitado}
              formatOptionLabel={(option, { context }) => {


                return (
                  <div style={{ display: 'flex' }}>
                    <small style={{ color: '#888' }}>
                      <strong>{option.value}</strong> - {option.equipamento?.DESC_TIPO_EQUIPAMENTO} • {option.equipamento?.DESC_MARCA_MODELO} • {option.equipamento?.DESC_DEPARTAMENTO} • {option.equipamento?.DESC_SITUACAO}
                    </small>
                  </div>
                );
              }}
            />



          </SelectContainer>
        </Label>
      </Div>
      <Div>
        <Label>
          Descreva detalhadamente o problema:
          <TextAreaContainer className={erros.descricao || erros.repetidos ? 'erro' : ''}>
            <TextAreaStyled
              className={erros.descricao || erros.repetidos ? 'erro' : ''}
              value={descricaoChamado}
              onChange={(e) => {
                const valor = e.target.value;
                setDescricaoChamado(valor);

                // Validação em tempo real: 3+ caracteres iguais seguidos
                const temRepeticao = /(.)\1\1/.test(valor); // Detecta 3 ou mais caracteres iguais seguidos
                setErros(prev => ({
                  ...prev,
                  repetidos: temRepeticao && valor.length > 0
                }));
              }}
              placeholder="Exemplo: Impressora HP não liga, já verifiquei os cabos e está conectada corretamente."
            />
          </TextAreaContainer>

          {/* Contador de caracteres + avisos */}
          <div style={{ marginTop: '6px', fontSize: '13px' }}>
            <span style={{ color: descricaoChamado.trim().length < 50 ? '#d32f2f' : '#666' }}>
              {descricaoChamado.trim().length} / 50 caracteres (mínimo)
            </span>

            {/* Aviso de caracteres repetidos */}
            {erros.repetidos && (
              <div style={{
                color: '#d32f2f',
                fontWeight: '500',
                marginTop: '4px',
                fontSize: '12.5px',
                display: 'flex',
                alignItems: 'center',
                gap: '4px'
              }}>
                Não é permitido usar 3 ou mais caracteres iguais seguidos (ex: aaa, 111, ===)
              </div>
            )}

            {/* Aviso de tamanho */}
            {/* {(descricaoChamado.trim().length < 50 || descricaoChamado.trim().length > 500) && !erros.repetidos && (
              <div style={{ color: '#d32f2f', fontSize: '12.5px', marginTop: '4px' }}>
                {descricaoChamado.trim().length < 50
                  ? 'A descrição deve ter no mínimo 50 caracteres.'
                  : 'A descrição deve ter no máximo 500 caracteres.'}
              </div>
            )} */}
          </div>
        </Label>
      </Div>


      <Div>
        <GreenButton onClick={salvarChamado} disabled={salvando}>
          {salvando ? 'Salvando...' : 'Salvar'}
        </GreenButton>


      </Div>

      <style jsx global>{`
        .swal2-container.custom-swal-container {
          z-index: 9999;
        }
      `}</style>
    </DivGeral>
  );
};

export default Form;




